const identityPart = (value) => {
  const part = Array.isArray(value) ? value[0] : value;
  return String(part == null ? "" : part).trim();
};

export const taskSelectionKey = (quotNo, codeNo) => {
  const code = identityPart(codeNo);
  return code ? JSON.stringify([identityPart(quotNo), code]) : null;
};

export const taskListDate = (value) => {
  if (!value) return "";
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
};

export const taskListCacheKey = (contrNo, div, date, employeeNo) =>
  JSON.stringify([identityPart(contrNo), identityPart(div), taskListDate(date), identityPart(employeeNo)]);

const taskCategoryKey = (row) => JSON.stringify([
  row.quotNo,
  row.listSEQ ?? null,
  identityPart(row.rootCode) || row.cat || "",
]);

export const compareTaskCategories = (left, right) => {
  const [leftQuote, leftSeq, leftRoot] = JSON.parse(left);
  const [rightQuote, rightSeq, rightRoot] = JSON.parse(right);
  return leftQuote.localeCompare(rightQuote) ||
    (Number(leftSeq) - Number(rightSeq)) ||
    String(leftRoot).localeCompare(String(rightRoot), undefined, { numeric: true });
};

export const taskSelectionRows = (rows, defaultQuote = "") =>
  (Array.isArray(rows) ? rows : []).map((row) => {
    const quotNo = identityPart(row.quotNo) || identityPart(defaultQuote);
    const codeNo = identityPart(row.codeNo);
    const task = { ...row, quotNo, codeNo };
    return {
      ...task,
      taskKey: taskSelectionKey(quotNo, codeNo),
      taskCategoryKey: taskCategoryKey(task),
    };
  });
